import { render, staticRenderFns } from "./campaigns-input-number-attempts.vue?vue&type=template&id=6a2eb910&"
import script from "./campaigns-input-number-attempts.vue?vue&type=script&lang=js&"
export * from "./campaigns-input-number-attempts.vue?vue&type=script&lang=js&"
import style0 from "./campaigns-input-number-attempts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports